import {
  deleteMymeByAuthorAPI,
  duplicateMymeAPI,
  GETOwnLocationBasedMymes,
  getOwnLocationBasedMymesAPI,
  POSTPublishMyme,
  publishMymeAPI,
  unpublishMymeAPI
} from '@myme/api';
import {
  DefaultPOSTorPATCHResType,
  Pagination,
  sendRequest,
  transformPaginationToSearchParams,
  UUID
} from '@myme/utils';

const getMymeIdRecord = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

/* **** DELETE **** /myme/:mymeId/author */
export const deleteMymeByAuthor = async (mymeId: UUID) =>
  sendRequest<null, null>(deleteMymeByAuthorAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** POST **** /myme/:mymeId/duplicate */
export const duplicateMyme = async (mymeId: UUID) =>
  sendRequest<DefaultPOSTorPATCHResType, null>(duplicateMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /myme/author/created */
export const getOwnLocationBasedMymes = async (pagination: Pagination) =>
  sendRequest<GETOwnLocationBasedMymes, null>(getOwnLocationBasedMymesAPI, {
    queryStringParams: [...transformPaginationToSearchParams(pagination), { key: 'type', value: 'LOCATION_BASED' }]
  });

/* **** POST **** /myme/:mymeId/publish */
export const publishMyme = async (mymeId: UUID) =>
  sendRequest<POSTPublishMyme, null>(publishMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** POST **** /myme/:mymeId/unpublish */
export const unpublishMyme = async (mymeId: UUID) =>
  sendRequest<POSTPublishMyme, null>(unpublishMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });
